module.exports = __webpack_public_path__ + "img/hr-combinator-displays.03a3a85b.png";